import { lazy } from "react";
import Loadable from "app/components/Loadable";

// Admin workflow screens
const WorkflowList = Loadable(lazy(() => import("./WorkflowList")));
const WorkflowStageList = Loadable(lazy(() => import("./WorkflowStageList")));
const StageFieldEditor = Loadable(lazy(() => import("./StageFieldEditor")));

const WorkflowAdminRoutes = [
  {
    path: "/admin/workflows",
    element: <WorkflowList />,
  },
  {
    path: "/admin/workflows/:workflowId/stages",
    element: <WorkflowStageList />,
  },
  {
    path: "/admin/workflows/:workflowId/stages/:stageId/fields",
    element: <StageFieldEditor />,
  },
];

export default WorkflowAdminRoutes;
